// extracted by mini-css-extract-plugin
module.exports = {"link":"socialLink-module__link___2iGh7","icon":"socialLink-module__icon___31s9s"};